/* eslint-disable no-alert */
import React, { Component } from 'react'
import { Form, TextArea, Grid, Button, Modal } from 'semantic-ui-react'
import firebase from 'firebase/app'

export default class ModalEditNote extends Component {
  state = {
    saving: false,
    note: '',
  }

  componentWillReceiveProps(nextProps) {
    const { order } = this.props

    if (nextProps.order && nextProps.order !== order) {
      this.setState({ note: nextProps.order.note })
    }
  }

  onModalClose = () => {
    const { onCancel } = this.props

    this.setState({ note: '', saving: false }, onCancel)
  }

  handleOnSavingClick = async () => {
    try {
      const { order } = this.props
      const { note } = this.state

      const orderRef = firebase
        .firestore()
        .collection('express_orders')
        .doc(order.id)

      this.setState({ saving: true })

      await orderRef.update({ note: note.trim() })

      this.setState({ saving: false }, this.onModalClose)
    } catch (error) {
      alert(error.message || error)
      this.setState({ saving: false })
    }
  }

  render() {
    const { visible } = this.props
    const { saving, note } = this.state

    return (
      <Modal
        open={visible}
        style={{ marginTop: 0, width: 600 }}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header>Delivery Note</Modal.Header>
        <Modal.Content style={{ padding: 0 }}>
          <Grid columns="equal" style={{ margin: 0 }}>
            <Grid.Row style={{ padding: 0 }}>
              <Grid.Column style={{ padding: 10 }}>
                <Form>
                  <TextArea
                    placeholder="Delivery note..."
                    style={{ minHeight: 200 }}
                    onChange={e => this.setState({ note: e.target.value })}
                    value={note}
                  />
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.onModalClose} negative disabled={saving}>
            Cancel
          </Button>
          <Button
            loading={saving}
            disabled={saving}
            onClick={() => this.handleOnSavingClick()}
            secondary
            content="Save"
          />
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/express/ModalEditNote.js